<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>{{ 'COMMON.CLOSE' | translate }}</button>
</mat-dialog-actions>
<div id="divmap2" #map2 class="tw-block sm:tw-block lg:tw-hidden tw-w-[100%] tw-h-[800px] tw-overflow-visible"></div>
